import React from 'react'

function Version() {
  return (
    <div className='text-center py-5 text-3xl'>
      Released Employer Version - 1.0.1
    </div>
  )
}

export default Version
